import React, { Component } from 'react';
import { Col, Row, Container, Image, Table } from 'react-bootstrap';
import { Card } from '../../components/Card/Card';
import Swal from 'sweetalert2'
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { registerStudent, registerAdmin, getUsers, deleteUsers, emailAdminRegistration } from '../../actions/clientActions';
import insertStudentsExample from '../../assets/img/insertStudentsExample.png';
import dateFormat from "dateformat";
import Spinner from '../common/Spinner';
import TextFieldGroup from '../common/TextFieldGroup';
import ReactToExcel from 'react-html-table-to-excel';
import CountUp from 'react-countup';
import { StatsCard } from '../StatsCard/StatsCard';
class AddStudents extends Component {
    handleFileUpload = event => {
        console.log(event.target.files[0].name);
    };
    constructor(props) {
        super(props);
        this.state = {
            file: null,
            name: '',
            email: '',
            nameAdmin: '',
            emailAdmin: '',
            password: '',
            errors: {},
            users: [],
            search: '',

        };
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onSubmitAdmin = this.onSubmitAdmin.bind(this);
        this.onChangeUpload = this.onChangeUpload.bind(this);
        this.onSubmitStudentsUpload = this.onSubmitStudentsUpload.bind(this);
    }
    onChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }
    onSubmit(e) {
        e.preventDefault();
        const newUser = {
            name: this.state.name,
            email: this.state.email,
        };
        this.props.registerStudent(newUser);
    }
    onSubmitAdmin(e) {
        e.preventDefault();
        const newUser = {
            name: this.state.nameAdmin,
            email: this.state.emailAdmin,
            password: this.state.password,
        };
        this.props.registerAdmin(newUser);
        
    this.setState({ email: '' })
    }

    onChangeUpload(e) {
        this.setState({ file: e.target.files[0] });
    }
    onSubmitStudentsUpload(e) {
        e.preventDefault()
        const formData = new FormData()
        formData.append(
            "file",
            this.state.file,
            this.state.file.name
        );

        console.log(this.state.selectedFile);
        axios.post(`/api/clients/insertStudents/:file`, formData).then(res => {
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Tabela studenata je uspešno uvezena!',
                showConfirmButton: false,
                timer: 3000
            })
            setTimeout(function () {
                window.location.reload()
            }, 3000);
        }
        )
    }
    deleteUser(_id) {
        Swal.fire({
            title: 'Da li sigurno želite da uklonite učesnika?',
            showDenyButton: true,
            confirmButtonText: 'Da',
            denyButtonText: 'Ne',
            customClass: {
                actions: 'my-actions',
                confirmButton: 'order-1',
                denyButton: 'order-2',
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.props.deleteUsers(_id)
            }
        })
    }
    componentDidMount() {
        this.props.getUsers();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({ errors: nextProps.errors });
        }
    }
    updateSearch(e) {
        this.setState({ search: e.target.value });
    }

    render() {
        const { errors } = this.state;
        const { loading } = this.props.users;
        const users = this.props.users.users.filter(users => {
            return (
                users.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1);
        });
        let count = users.length;
        let admini;
        let studenti;
        var countAdmin = 0;
        var countStudent = 0;
        for (const user of users) {
            if (user.position === 'Admin') {
                countAdmin += 1;
            }
            else if (user.position === 'Student') {
                countStudent += 1;
            }
        }
        admini = countAdmin;
        studenti = countStudent;

        console.log(users.length);
        let userItems;
        if (users === null || loading) {
            userItems = (
                <tr>
                    <td>
                        <Spinner />
                    </td>
                </tr>
            );
        }

        else {
            if (users.length > 0) {
                userItems = users.map(user => (
                    <tr key={user._id}>
                        <td style={{ backgroundColor: '#F8EDE3' }}>{dateFormat(user.date, "dd.mm.yyyy.")}</td>
                        <td style={{ backgroundColor: '#FEFCF3' }}>{user.name}</td>
                        <td style={{ backgroundColor: '#FEFCF3' }}>{user.email}</td>
                        <td style={{ backgroundColor: '#F5EBE0' }}>{user.position}</td>
                        <td style={{ backgroundColor: '#F8EDE3', justifyItems: 'center' }}>
                            <button style={{ backgroundColor: '#DBA39A', border: 'none' }}
                                type="button"
                                className=" btn btn-sm btn-fill"
                                onClick={this.deleteUser.bind(this, user._id)}
                            >
                                Ukloni
                            </button>
                        </td>
                    </tr>
                ));
            }
            else {
                userItems = (
                    <tr>
                        <td>Još uvek nema registrovanih učesnika</td>
                    </tr>
                );
            }
        }


        return (
            <Container>
                <Row className='justify-content-center'>
                    <Col lg={3} sm={3}>
                        <StatsCard
                            bigIcon={<i className="pe-7s-id" style={{ color: '#525E75' }}/>}
                            statsText="Admini"
                            statsValue={
                                <CountUp
                                    className="account-balance"
                                    start={0}
                                    end={admini}
                                    duration={1}
                                    useGrouping={true}
                                />}
                            statsIconText="Ukupan broj registrovanih administratora"
                        />
                    </Col>
                    <Col lg={3} sm={3}>
                        <StatsCard
                            bigIcon={<i className="pe-7s-users"  style={{ color: '#525E75' }}/>}
                            statsText="Učesnici"
                            statsValue={
                                <CountUp
                                    className="account-balance"
                                    start={0}
                                    end={count}
                                    duration={1}
                                    useGrouping={true}
                                />}
                            statsIconText="Ukupan broj registrovanih učesnika"
                        />
                    </Col>
                    <Col lg={3} sm={3}>
                        <StatsCard
                            bigIcon={<i className="pe-7s-study" style={{ color: '#525E75' }}/>}
                            statsText="Studenti"
                            statsValue={
                                <CountUp
                                    className="account-balance"
                                    start={0}
                                    end={studenti}
                                    duration={1}
                                    useGrouping={true}
                                />}
                            statsIconText="Ukupan broj registrovanih studenata"
                        />
                    </Col>
                </Row>
                <Row></Row>
                <Row>
                    <Col lg={4} sm={3}>

                        <Card
                            title="Registracija admina"
                            category="Registrujte pojedinačno administratore"
                            
                            content={
                                <><div>
                                    <form noValidate onSubmit={this.onSubmitAdmin} style={{ fontFamily: 'FontAwesome' }}>
                                        <TextFieldGroup
                                            label="Ime i prezime"
                                            placeholder="&#xf007; Ime i Prezime"
                                            name="nameAdmin"
                                            value={this.state.nameAdmin}
                                            onChange={this.onChange}
                                            error={errors.nameclient}
                                        />
                                        <TextFieldGroup

                                            label="Email Adresa"
                                            placeholder="&#xf0e0; Email Adresa"
                                            name="emailAdmin"
                                            type="email"
                                            value={this.state.emailAdmin}
                                            onChange={this.onChange}
                                            error={errors.emailclient}

                                        />
                                        <TextFieldGroup
                                            label="Lozinka"
                                            placeholder="&#xf023; Lozinka"
                                            name="password"
                                            type="password"
                                            value={this.state.password}
                                            onChange={this.onChange}
                                            error={errors.passwordclient}
                                        />
                                        <input
                                            style={{ backgroundColor: '#6096B4', border: 'none' }}
                                            type="submit"
                                            value='Registruj admina'
                                            className="btn btn-fill btn-info btn-block mt-4"
                                        />
                                    </form>
                                </div>
                                </>
                            }
                        /></Col>
                    <Col lg={4} sm={3}>

                        <Card
                            title="Registracija studenta"
                            category="Registrujte pojedinačno studente"
                            content={
                                <><div>
                                    <form noValidate onSubmit={this.onSubmit} style={{ fontFamily: 'FontAwesome' }}>
                                        <TextFieldGroup
                                            label="Ime i prezime"
                                            placeholder="&#xf007; Ime i Prezime"
                                            name="name"
                                            value={this.state.name}
                                            onChange={this.onChange}
                                            error={errors.nameclient}
                                        />
                                        <TextFieldGroup
                                            label="Email Adresa"
                                            placeholder="&#xf0e0; Email Adresa"
                                            name="email"
                                            type="email"
                                            value={this.state.email}
                                            onChange={this.onChange}
                                            error={errors.emailclient}
                                        />
                                        <input 
                                            style={{ backgroundColor: '#6096B4', border: 'none' }}
                                            type="submit"
                                            value="Registruj studenta"
                                            className="btn btn-fill btn-info btn-block mt-4"
                                        />
                                    </form>
                                </div>
                                </>
                            }
                        /></Col>
                    <Col lg={4} sm={3}>

                        <Card
                            title="Upload studenata"
                            category="Dodajte excel tabelu sa spiskom studenata"
                            content={
                                <>
                                    <div className="container">
                                        <div className="row">
                                            <form onSubmit={this.onSubmitStudentsUpload} className='justify-content-center' style={{ fontFamily: 'FontAwesome' }}>
                                                <input type="file" onChange={this.onChangeUpload}name="file" accept=".xls,.xlsx" />
                                                <button className="btn btn-info btn-fill btn-sm" type="submit" 
                                                    style={{ backgroundColor: '#6096B4', border: 'none' }} >Potvrdi</button>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="container">
                                        <Table striped hover id="primer" style={{ display: 'none' }}>
                                            <tbody>
                                                <tr>
                                                    <td>email</td>
                                                    <td>name</td>
                                                </tr>
                                                <tr>
                                                    <td>novakdjokovic@gmail.com</td>
                                                    <td>Novak Đoković</td>
                                                </tr>
                                                <tr>
                                                    <td>rafaelnadal@yahoo.com</td>
                                                    <td>Rafael Nadal</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <p className="text-muted">Validan format za excel upload:</p>
                                        <Image
                                            src={insertStudentsExample}
                                            fluid
                                        />
                                        <ReactToExcel
                                            font="TimesNewRoman"
                                            className="btn btn-fill btn-secondary btn-sm"
                                            table="primer"
                                            filename={'Template za excel upload'}
                                            sheet="Sheet1"
                                            buttonText="Preuzmite template za excel import"
                                            style={{ fontFamily: 'FontAwesome' }}
                                        />
                                    </div>
                                </>
                            }
                        />
                    </Col>

                </Row>

                <Row>
                    <Col lg={3} sm={3}>
                        <div className="col-md-10">
                            <input
                                name="search"
                                type="text"
                                placeholder="&#xf002; Pretraga učesnika"
                                value={this.state.search}
                                onChange={this.updateSearch.bind(this)}
                                style={{ marginBottom: '33px', fontFamily: 'FontAwesome' }}
                                className="form-control form-control-lg col-md-4"
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={8} sm={4}>
                        <Card
                            title="Učesnici"
                            category="Spisak registrovanih učesnika"
                            ctTableFullWidth
                            ctTableResponsive
                            content={
                                <>
                                    <Table striped hover id="table-to-xls" >
                                        <thead>
                                            <tr>
                                                <th>Datum registracije</th>
                                                <th>Ime</th>
                                                <th>Email</th>
                                                <th>Pozicija</th>
                                                <th>Brisanje</th>
                                            </tr>
                                        </thead>
                                        <tbody>{userItems}</tbody>
                                    </Table>
                                    <ReactToExcel
                                        font="TimesNewRoman"
                                        className="btn  btn-fill btn-sm"
                                        table="table-to-xls"
                                        filename={'Spisak učesnika konferencije ' + new Date().toLocaleDateString("rs-RS")}
                                        sheet="sheet 1"
                                        buttonText="Preuzmite excel listu učesnika"
                                    />
                                </>}
                        /></Col>
                </Row>
            </Container>
        );
    }

}

AddStudents.propTypes = {
    registerStudent: PropTypes.func.isRequired,
    registerAdmin: PropTypes.func.isRequired,
    emailAdminRegistration: PropTypes.func.isRequired,
    getUsers: PropTypes.func.isRequired,
    deleteUsers: PropTypes.func.isRequired,
    users: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    errors: state.errors,
    users: state.users,
});

export default connect(
    mapStateToProps,
    { registerStudent, registerAdmin, getUsers, deleteUsers, emailAdminRegistration }
)(AddStudents);